import React from "react";
import {createRoot} from "react-dom/client";
import ResourcesPage from "./components/ResourcesPage";

export default () => {

  const dom = document.querySelector('[data-resources]');
  if (dom) {
    const root = createRoot(dom);
    root.render(<ResourcesPage endpoint={dom.getAttribute('data-resources')} />)
  }

}
